import industryInfo1 from "./1.js";
import industryInfo2 from "./2.js";
import industryInfo3 from "./3.js";
import industryInfo4 from "./4.js";
import industryInfo5 from "./5.js";
import industryInfo6 from "./6.js";
import industryInfo7 from "./7.js";
import industryInfo8 from "./8.js";
import industryInfo9 from "./9.js";
import industryInfo10 from "./10.js";
import industryInfo11 from "./11.js";
export default{
    industryInfo1:industryInfo1.industryInfo,
    industryInfo2:industryInfo2.industryInfo,
    industryInfo3:industryInfo3.industryInfo,
    industryInfo4:industryInfo4.industryInfo,
    industryInfo5:industryInfo5.industryInfo,
    industryInfo6:industryInfo6.industryInfo,
    industryInfo7:industryInfo7.industryInfo,
    industryInfo8:industryInfo8.industryInfo,
    industryInfo9:industryInfo9.industryInfo,
    industryInfo10:industryInfo10.industryInfo,
    industryInfo11:industryInfo11.industryInfo
}


// WEBPACK FOOTER //
// ./src/data/industryInfo/index.js